import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _map from 'lodash/map';
import _curry from 'lodash/curry';
import _noop from 'lodash/noop';
import _isEmpty from 'lodash/isEmpty';

// Constants
import SORT_ORDER from '@tekion/tekion-base/constants/sortOrder';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { defaultMemoize } from 'reselect';
import actionTypes from '../TableManager/constants/actionTypes';
import HeaderWithSort from './atoms/headerWithSort';
export default function withCustomerSortTable(ComposedComponent) {
  var CustomSortTable = /*#__PURE__*/function (_PureComponent) {
    _inherits(CustomSortTable, _PureComponent);
    var _super = _createSuper(CustomSortTable);
    function CustomSortTable() {
      var _this;
      _classCallCheck(this, CustomSortTable);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "mapSortableColumns", defaultMemoize(function (columns, sortDetails) {
        return _map(columns, _this.addColumnHeaderProps(sortDetails));
      }));
      _defineProperty(_assertThisInitialized(_this), "addSortingToColumnHeader", _curry(function (sortDetails, column) {
        var headerTitle = column.Header,
          isRightAlign = column.isRightAlign,
          key = column.key;
        if (!column.sortable) return column;
        return _objectSpread(_objectSpread({}, column), {}, {
          Header: /*#__PURE__*/React.createElement(HeaderWithSort, {
            headerTitle: headerTitle,
            sortType: sortDetails[key],
            isRightAlign: isRightAlign,
            onClick: _this.handleSortUpdate(column)
          }),
          sortable: false
        });
      }));
      _defineProperty(_assertThisInitialized(_this), "addColumnHeaderProps", _curry(function (sortDetails, column) {
        var sanitizedColumn = column || EMPTY_OBJECT;
        if (_isEmpty(sanitizedColumn.columns)) return _this.addSortingToColumnHeader(sortDetails)(sanitizedColumn);
        var sortableColumns = _map(sanitizedColumn.columns, _this.addSortingToColumnHeader(sortDetails));
        return _objectSpread(_objectSpread({}, sanitizedColumn), {}, {
          columns: sortableColumns,
          sortable: false
        });
      }));
      _defineProperty(_assertThisInitialized(_this), "handleSortUpdate", function (column) {
        return function () {
          var onAction = _this.props.onAction;
          var key = column.key;
          var sortTypeMap = _this.setSortType(key);
          onAction({
            type: actionTypes.TABLE_ITEMS_SORT,
            payload: {
              value: {
                column: column,
                sortTypeMap: sortTypeMap
              }
            }
          });
        };
      });
      _defineProperty(_assertThisInitialized(_this), "setSortType", function (key) {
        var _this$props = _this.props,
          _this$props$sortDetai = _this$props.sortDetails,
          sortDetails = _this$props$sortDetai === void 0 ? EMPTY_OBJECT : _this$props$sortDetai,
          isMultiSort = _this$props.isMultiSort;
        var selectedSortConfig = _defineProperty({}, key, sortDetails[key] === SORT_ORDER.DESC ? SORT_ORDER.ASC : SORT_ORDER.DESC);
        return isMultiSort ? _objectSpread(_objectSpread({}, sortDetails), selectedSortConfig) : selectedSortConfig;
      });
      return _this;
    }
    _createClass(CustomSortTable, [{
      key: "render",
      value: function render() {
        var props = this.props,
          state = this.state;
        var _props$sortDetails = props.sortDetails,
          sortDetails = _props$sortDetails === void 0 ? EMPTY_OBJECT : _props$sortDetails,
          columns = props.columns;
        return /*#__PURE__*/React.createElement(ComposedComponent, _extends({}, props, {
          tableManagerProps: _objectSpread(_objectSpread({}, props.tableManagerProps), {}, {
            showMultiSort: false
          })
        }, state, {
          columns: this.mapSortableColumns(columns, sortDetails)
        }));
      }
    }]);
    return CustomSortTable;
  }(PureComponent);
  CustomSortTable.propTypes = {
    sortDetails: PropTypes.object,
    isMultiSort: PropTypes.bool,
    onAction: PropTypes.func
  };
  CustomSortTable.defaultProps = {
    sortDetails: EMPTY_OBJECT,
    isMultiSort: true,
    onAction: _noop
  };
  return CustomSortTable;
}